import { createContext } from "react";
import { IAppMainStateContext } from "./models/IAppMainStateContext.ts";
import { Orientation } from "../consts/orientation.ts";
import { DeviceSize } from "../consts/device.ts";
import { NotificationStatus } from "../components/notification/Notification.tsx";

export const AppMainStateContext = createContext<IAppMainStateContext>({
  isMobile: false,
  isIOS: false,
  appStates: { isCookiesAgreed: "not set", qualityLevelPreference: "AUTO" },
  isSearchModalOpen: false,
  isModalOpen: false,
  isDisabledCloseModal: false,
  isLoginModalOpen: false,
  isNotificationVisible: false,
  orientation: Orientation.PORTRAIT_PRIMARY,
  windowWidth: DeviceSize.laptop,
  notificationData: {
    description: "",
    status: NotificationStatus.info,
    title: "",
  },
  setIsCookiesAgreed: () => { },
  setVideoQualityPreference: () => { },
  setIsSearchModalOpen: () => { },
  setIsNotificationVisible: () => { },
  setNotificationData: () => { },
  closeModal: () => { },
  openModal: () => { },
  openLoginModal: () => { },
});
